'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Rewards = void 0;
var transport_1 = require("../../transport");
var Rewards = /** @class */ (function () {
    function Rewards() {
    }
    Rewards.prototype.getAll = function (params) {
        return transport_1.transport.request('rewards/getAll', params);
    };
    Rewards.prototype.getShopRewards = function (params) {
        return transport_1.transport.request('rewards/getVirtualShopItems', params);
    };
    Rewards.prototype.claimReward = function (params) {
        return transport_1.transport.request('rewards/claimReward', params);
    };
    Rewards.prototype.getUserRewards = function (params) {
        return transport_1.transport.request('rewards/getUserRewards', params);
    };
    Rewards.prototype.history = function (params) {
        return transport_1.transport.request('rewards/history', params);
    };
    Rewards.prototype.newlyAwardedTokens = function () {
        return transport_1.transport.request('rewards/newlyAwardedTokens');
    };
    Rewards.prototype.buyTokens = function (params) {
        return transport_1.transport.request('rewards/buyTokens', params);
    };
    return Rewards;
}());
exports.Rewards = Rewards;
